import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { map, catchError, of } from 'rxjs';

import { MeService } from '../api/me.service';

@Injectable({ providedIn: 'root' })
export class AdminGuard implements CanActivate {
  constructor(
    private readonly meService: MeService,
    private readonly router: Router
  ) {}

  canActivate() {
    return this.meService.getMe().pipe(
      map((me) => {
        if (me.user.role === 'global_admin') {
          return true;
        }

        return this.router.parseUrl('/workspace');
      }),
      catchError(() => of(this.router.parseUrl('/')))
    );
  }
}
